import React, { ReactElement } from 'react';

type Props = {
  item: {
    text: string;
  };
  children: [];
};
export default function Code({ item, children }: Props): ReactElement {
  return <code>{children}</code>;
}
